import React, { useState, useCallback } from 'react';
import { NavLink, useLocation, Routes, Route } from 'react-router-dom';
import clsx from 'clsx';
import { T } from '../../utils/I18n/I18n';
import PersonalAreaAddress from '../../components/PersonalArea/PersonalAreaAddress/PersonalAreaAddress';
import PersonalAreaAddToHomeScreen from '../../components/PersonalArea/PersonalAreaAddToHomeScreen/PersonalAreaAddToHomeScreen';
import PersonalAreaClub from '../../components/PersonalArea/PersonalAreaClub/PersonalAreaClub';
import PersonalAreaEditPersonalData from '../../components/PersonalArea/PersonalAreaEditPersonalData/PersonalAreaEditPersonalData';
import PersonalAreaNewsletter from '../../components/PersonalArea/PersonalAreaNewsletter/PersonalAreaNewsletter';
import CreditMemo from '../../components/PersonalArea/PersonalAreaOrders/CreditMemo/CreditMemo';
import Invoice from '../../components/PersonalArea/PersonalAreaOrders/Invoice/Invoice';
import PersonalAreaOrders from '../../components/PersonalArea/PersonalAreaOrders/PersonalAreaOrders';
import PersonalAreaOrdersDetails from '../../components/PersonalArea/PersonalAreaOrders/PersonalAreaOrdersDetails';
import Shipment from '../../components/PersonalArea/PersonalAreaOrders/Shipment/Shipment';
import PersonalAreaPersonalData from '../../components/PersonalArea/PersonalAreaPersonalData/PersonalAreaPersonalData';
import PersonalAreaPrivacySettings from '../../components/PersonalArea/PersonalAreaPrivacySettings/PersonalAreaPrivacySettings';
import PersonalAreaWishlist from '../../components/PersonalArea/PersonalAreaWishlist/PersonalAreaWishlist';
import PersonalAreaWishlistShare from '../../components/PersonalArea/PersonalAreaWishlistShare/PersonalAreaWishlistShare';
import { useUserContext } from '../../context/UserContext';
import useResponsive from '../../hooks/useResponsive';
import PrivateRoute from '../../utils/privateRoute';
import './PersonalArea.scss';

const MENU_ITEMS = [
    { path: '', id: 'personalArea.personalInfo', exact: true },
    { path: 'orders', id: 'personalArea.orders' },
    { path: 'wishlist', id: 'personalArea.wishlist' },
    { path: 'address', id: 'personalArea.address' },
    { path: 'edit', id: 'personalArea.profileInfo' },
    { path: 'loyalty', id: 'personalArea.club' },
    { path: 'newsletter', id: 'personalArea.newsletter' },
    { path: 'privacy', id: 'personalArea.privacy' },
    { path: '/', id: 'user.logout', isLogout: true },
];

const PersonalArea = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(true);
    const { pathname } = useLocation();
    const baseUrl = '/customer/account';
    const { isMobile } = useResponsive();
    const { logOut } = useUserContext();

    const toggleMenu = useCallback(() => {
        setIsMenuOpen((prev) => !prev);
    }, []);

    const hideMenu = useCallback(() => {
        if (isMobile) setIsMenuOpen(false);
    }, [isMobile]);

    const handleLogout = useCallback(() => {
        hideMenu();
        logOut();
    }, [hideMenu, logOut]);

    return (
        <div className="user">
            <input
                className="user-dropdown__checkbox"
                type="checkbox"
                name="user-menu"
                id="user-menu"
                checked={isMenuOpen}
                onChange={toggleMenu}
            />

            <label htmlFor="user-menu" className="user-dropdown">
                <T id="registration.personalInfo" />
            </label>

            <ul
                className={clsx('user__menu', {
                    'user__menu_hidden': !isMenuOpen && isMobile,
                })}
            >
                {MENU_ITEMS.map(({ path: itemPath, id, isLogout }) => (
                    <MenuListItem
                        key={id}
                        path={`${baseUrl}/${itemPath}`}
                        onClick={isLogout ? handleLogout : hideMenu}
                    >
                        <T id={id} />
                    </MenuListItem>
                ))}
                <PersonalAreaAddToHomeScreen />
            </ul>

            <div className="user__subject-wrapper">
                <Routes>
                    <Route path="orders" element={<PrivateRoute><PersonalAreaOrders /></PrivateRoute>} />
                    <Route path="orders/:ordersDetailsId" element={<PrivateRoute><PersonalAreaOrdersDetails /></PrivateRoute>} />
                    <Route path="orders/invoice/:ordersDetailsId" element={<PrivateRoute><Invoice /></PrivateRoute>} />
                    <Route path="orders/creditmemo/:ordersDetailsId" element={<PrivateRoute><CreditMemo /></PrivateRoute>} />
                    <Route path="orders/shipment/:ordersDetailsId" element={<PrivateRoute><Shipment /></PrivateRoute>} />
                    <Route path="wishlist" element={<PrivateRoute><PersonalAreaWishlist /></PrivateRoute>} />
                    <Route path="wishlist/share/:wishlistId" element={<PrivateRoute><PersonalAreaWishlistShare /></PrivateRoute>} />
                    <Route path="address" element={<PrivateRoute><PersonalAreaAddress /></PrivateRoute>} />
                    <Route path="edit" element={<PrivateRoute><PersonalAreaEditPersonalData /></PrivateRoute>} />
                    <Route path="loyalty" element={<PrivateRoute><PersonalAreaClub /></PrivateRoute>} />
                    <Route path="newsletter" element={<PrivateRoute><PersonalAreaNewsletter /></PrivateRoute>} />
                    <Route path="privacy" element={<PrivateRoute><PersonalAreaPrivacySettings /></PrivateRoute>} />
                    <Route path="/" element={<PrivateRoute><PersonalAreaPersonalData /></PrivateRoute>} />
                    <Route path="*" element={<div>404 - Strona nie znaleziona</div>} />
                </Routes>
            </div>
        </div>
    );
};

const MenuListItem = React.memo(({ path, onClick, children }) => (
    <li onClick={onClick}>
        <NavLink
            className="user__menu-item"
            // activeClassName="user__menu-item_active"
            to={path}
        >
            {children}
        </NavLink>
    </li>
));

export default React.memo(PersonalArea);